import { render, staticRenderFns } from "./openNoticePage.vue?vue&type=template&id=3c84b0ee&"
import script from "./openNoticePage.vue?vue&type=script&lang=js&"
export * from "./openNoticePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports